'use client'

import React, { useState, useRef } from 'react'
import Image from 'next/image'
import { FormWidgetProps } from '@interfaces/giCar'
import { IMAGES } from './config'
import styles from './FormWidget.module.scss'

const FormWidget: React.FC<FormWidgetProps> = ({
  registrationNumber,
  error,
  isLoading,
  onChangeHandler,
  onBlurHandler,
  onClickHandler,
  onKeyPressHandler,
  formData,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div className={styles.formWidgetContainer}>
      <div className={styles.formWrapper}>
        <div className={styles.inputSection}>
          <div className={`${styles.inputWrapper} ${isFocused ? styles.focused : ''} ${error ? styles.error : ''}`}>
            <div className={styles.countryBadge}>
              <div className={styles.logoIcon}>
                <Image
                  src={IMAGES.FLAG.url}
                  alt={IMAGES.FLAG.alt}
                  width={IMAGES.FLAG.width}
                  height={IMAGES.FLAG.height}
                  margin-bottom={2}
                  priority
                />
              </div>
              <div className={styles.indText}>
                <Image
                  src={IMAGES.IND.url}
                  alt={IMAGES.IND.alt}
                  width={IMAGES.IND.width}
                  height={IMAGES.IND.height}
                  priority
                />
              </div>
            </div>
            <input
              ref={inputRef}
              type="text"
              className={styles.input}
              value={registrationNumber}
              onChange={e => {
                const upperValue = e.target.value.toUpperCase()
                onChangeHandler(upperValue)
              }}
              onBlur={() => {
                setIsFocused(false)
                onBlurHandler()
              }}
              onFocus={() => setIsFocused(true)}
              onKeyPress={onKeyPressHandler}
              placeholder={formData?.PLACEHOLDER}
              disabled={isLoading}
              maxLength={formData?.MAX_LENGTH}
              autoCapitalize="characters"
            />
          </div>
          {error && (
            <div className={styles.errorMessage}>
              <svg className={styles.errorIcon} viewBox="0 0 24 24" width="16" height="16">
                <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" />
                <circle cx="12" cy="16" r="1" fill="currentColor" />
              </svg>
              {formData?.ERROR_MESSAGE}
            </div>
          )}
          <div className={styles.buttonSection}>
            <button
              type="button"
              className={styles.submitButton}
              onClick={onClickHandler}
              disabled={isLoading || !registrationNumber.trim()}
              aria-label={formData?.BUTTON_TEXT}>
              {isLoading ? (
                <>
                  <span className={styles.spinner}></span>
                  <span>{formData?.LOADING_TEXT}</span>
                </>
              ) : (
                formData?.BUTTON_TEXT
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormWidget
